import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { AccordionApplicantVM, PracticeDetailVM } from 'practice/view-models/practice-detail';
import Form from './form';
import ItalianForeignStateDocument from 'front-office/components/shared/generality/release-card/italian-foreign-state-document';
import { noop } from 'shell/utils/noop';

interface AccordionApplicantProps {
  disabled?: boolean;
}

const AccordionApplicantComponent = ({
  disabled = false,
}: AccordionApplicantProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<PracticeDetailVM>();

  const isEqualToHolder = useMemo(
    () => formContext.values?.practice?.flagApplicant,
    [formContext.values?.practice?.flagApplicant]
  );

  const onChange = useEventCallback(
    (key: keyof AccordionApplicantVM, value: AccordionApplicantVM[keyof AccordionApplicantVM]) => {
      formContext.setFieldValue('applicant', {
        ...(formContext.values.applicant || {}),
        [key]: value,
      });
    }
  );

  if (isEqualToHolder === '0') {
    return <></>;
  }

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-applicant-content"
        id="accordion-applicant-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Richiedente</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form onChange={onChange} disabled={disabled} values={formContext.values.applicant} />
        {formContext.values.practice?.flagApplicant === '1' ? (
          <ItalianForeignStateDocument
            isForeign={formContext.values.applicant?.isForeignDocument}
            values={formContext.values.applicant}
            onChange={noop}
            onChangeValues={noop}
            disabled
          />
        ) : undefined}
      </AccordionDetails>
    </Accordion>
  );
};

AccordionApplicantComponent.displayName = 'Practice Detail - Form - accordion applicant';

const AccordionApplicant = memo(AccordionApplicantComponent);

export default AccordionApplicant;
